var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "estates-list",
      class: _vm.showMap ? "container-fluid" : "container no-map"
    },
    [
      _c(
        "div",
        { staticClass: "row-maps" },
        [
          _c(
            "div",
            { staticClass: "search-top" },
            [
              !_vm.$root.is_mobile
                ? _c("estates-search-filters", {
                    attrs: {
                      config: _vm.config,
                      config_map: _vm.config_map,
                      districts_list: _vm.districts_list
                        ? _vm.districts_list
                        : _vm.districts_list_city,
                      geo_data: _vm.geoData,
                      section: _vm.section,
                      "search-data": _vm.filters,
                      types_list: _vm.typesList,
                      "save-search-disable": _vm.saveSearchDisable
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-lists" }, [
            _c(
              "div",
              { staticClass: "result-list" },
              [
                _c(
                  "estates-list-breadcrumb",
                  [_c("template", { slot: "body" }, [_vm._t("breadcrumb")], 2)],
                  2
                ),
                _vm._v(" "),
                _c(
                  "estates-list-title",
                  [_c("template", { slot: "body" }, [_vm._t("title")], 2)],
                  2
                ),
                _vm._v(" "),
                _c(
                  "estates-list-cities",
                  {
                    attrs: {
                      cities: _vm.search.cities,
                      cities_list: _vm.cities_list ? _vm.cities_list : null
                    }
                  },
                  [
                    _c("template", { slot: "body" }, [_vm._t("cities-list")], 2)
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "estates-list-districts",
                  {
                    attrs: {
                      city: _vm.filters.city,
                      districts: _vm.search.districts,
                      districts_list: _vm.districts_list
                        ? _vm.districts_list
                        : _vm.districts_list_city,
                      quarters: _vm.search.quarters
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "body" },
                      [_vm._t("districts-list")],
                      2
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.search.districts &&
                !_vm.search.districts.toString().includes("|")
                  ? _c(
                      "estates-list-quarters",
                      [
                        _c(
                          "template",
                          { slot: "body" },
                          [_vm._t("quarters-list")],
                          2
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "estates-list-heading",
                  {
                    attrs: {
                      config: _vm.config,
                      config_map: _vm.config_map,
                      search: _vm.filters,
                      geo_data: _vm.geoData,
                      types_list: _vm.typesList,
                      section: _vm.section,
                      fallback: _vm.fallback,
                      sort_enable: _vm.estates ? true : false
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "estates-count" },
                      [_vm._t("estates-list-heading")],
                      2
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "estates-list",
                  {
                    attrs: {
                      search: _vm.filters,
                      map_center: _vm.mapCenter,
                      pagination: _vm.pagination,
                      section: _vm.section,
                      config: _vm.config
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "estates" },
                      [_vm._t("estate-cards")],
                      2
                    ),
                    _vm._v(" "),
                    _vm._t("pagination")
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("seo-links")
              ],
              2
            )
          ]),
          _vm._v(" "),
          !_vm.$root.is_mobile
            ? _c("estates-map-list", {
                staticClass: "col-maps",
                attrs: {
                  config_map: _vm.config_map,
                  search: _vm.filters,
                  section: _vm.section,
                  map_center: _vm.mapCenter,
                  mapDrawable:
                    _vm.config_map.map_drawable && _vm.section != "construction"
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }